import { fetchExchangeRates } from '../../ducks/exchangeRates.duck';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'landing-page';

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  // OPTIMIZATION: Defer exchange rates loading to prevent blocking initial page render
  // Exchange rates are not critical for landing page display
  const exchangeRatesPromise = new Promise((resolve) => {
    // Use setTimeout to defer the API call until after initial render
    setTimeout(() => {
      const { exchangeRates } = getState().exchangeRate;
      if (typeof window !== 'undefined' && exchangeRates && exchangeRates.length === 0) {
        dispatch(fetchExchangeRates());
      }
      resolve();
    }, 100); // 100ms delay to allow page to render first
  });

  // OPTIMIZATION: Load page assets immediately (critical for page display)
  const pageAssetsPromise = dispatch(fetchPageAssets(pageAsset, true));

  // OPTIMIZATION: Return page assets immediately, let exchange rates load in background
  return pageAssetsPromise.then((result) => {
    // Start exchange rates loading in background
    exchangeRatesPromise.catch(() => {
      // Silently handle exchange rates loading errors
      console.warn('Exchange rates loading failed, continuing with page display');
    });

    return result;
  });
};
